export enum AccessLevel {
  normal = 1,
  advanced = 2,
  full = 3,
  manufacturer = 4,
  unmodifiable = 999,
}
